await import('D:/work/admin.aumagic.com.au-umi4/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('D:/work/admin.aumagic.com.au-umi4/src/.umi/umi.ts');
export default 1;